import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import { SysCodeDto } from 'src/dtos/code/sysCodeDto';

import { defaultPUR1030_R01Filter, PUR1030_R01Filter, usePUR1030_R01Store } from 'src/containers/mes/PUR/PUR1030_R01/Store_PUR1030_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import useUiuxStore, { PUR1020_PUR1030NavigationData, Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { deletePUR1030_R01, downloadExcel_PUR1030_R01, getPUR1030_R01AllCount, getPUR1030_R01DetailList, getPUR1030_R01List, getPUR1030_R01One, getPdfBlob_PUR1030_R01, patchPUR1030_R01, postPUR1030_R01 } from "./Api_PUR1030_R01";
import { defaultPUR1030_R01DetailDto, defaultPUR1030_R01HeaderDto, PUR1030_R01DetailDto, PUR1030_R01Dto, PUR1030_R01HeaderDto } from './Dto_PUR1030_R01';
import { AgGridReact } from 'ag-grid-react';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { CompanyDto } from 'src/dtos/company/companyDto';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { validateString } from 'src/utils/string/stringUtil';
import { validateCustomCd, validateEmployeeCd } from 'src/utils/grid/GridValidateContent';
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import {
	buildCommonCodeRequirements,
	PUR1030_R01_HEADER_ROW_VALIDATE,
} from 'src/utils/commonCode/commonCodeRequirementConfig';
import { useQzPrint } from 'src/hooks/useQzPrint';
import qz from 'qz-tray';
import { useWMS1130_R01Store } from '../../WMS/WMS1130_R01/Store_WMS1130_R01';
import { applyOrderStatusOnly, applyOrderStatusToList, isOrderLocked } from 'src/utils/order/orderUtils';

interface Props {
	gridRef: React.RefObject<AgGridReact<PUR1030_R01HeaderDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<PUR1030_R01DetailDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}



export const Content_PUR1030_R01 = (props: Props) => {

	const {
		gridRef, detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	const { vatTypeList, moneyCdList, wmsCdList, compCdList, customCdList, employeeCdList, warehouseCdList, itemCdMap } = useCommonCodeStore();

	
	const {
		PUR1030_R01Filter, setPUR1030_R01Filter,
		PUR1030_R01PastFilter, setPUR1030_R01PastFilter,
		PUR1030_R01List, setPUR1030_R01List,
		editPUR1030_R01, setEditPUR1030_R01,
		selectedPUR1030_R01, setSelectedPUR1030_R01,
		deletedPUR1030_R01DetailList, setDeletedPUR1030_R01DetailList, addDeletedPUR1030_R01DetailList, removeDeletedPUR1030_R01DetailList, 
		selectedPUR1030_R01DetailList, setSelectedPUR1030_R01DetailList, addSelectedPUR1030_R01DetailList, removeSelectedPUR1030_R01DetailList,
		PUR1030_R01DetailList, setPUR1030_R01DetailList, insertPUR1030_R01DetailList,
		originalPUR1030_R01DetailList, setOriginalPUR1030_R01DetailList,
		allCount, setAllCount,
		detailFetchTrigger, setDetailFetchTrigger,
		initData,
		setScrollTop, setDetailScrollTop,
	} = usePUR1030_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	const { printPdfFromBlob } = useQzPrint();
	const { PUR1020_PUR1030NavigationData, setPUR1020_PUR1030NavigationData, PUR1021_PUR1030NavigationData, setPUR1021_PUR1030NavigationData } = useUiuxStore();

	useFetchActionbarAuth("PUR1030_R01");

	const handlePrintClick = useCallback(async () => {
		if (!selectedPUR1030_R01 || !selectedPUR1030_R01.purchaseOrderNo) {
			showWarning("출력할 발주번호를 선택하세요.");
			setMessage("출력할 발주번호를 선택하세요.");
			return;
		}
		setLoadingSpinner(true);
		try {
			const blob = await getPdfBlob_PUR1030_R01(selectedPUR1030_R01.purchaseOrderNo);
			if (qz.websocket.isActive()) {
				const ok = await printPdfFromBlob(blob, "report1");
				if (ok) {
					showSuccess("PDF 출력을 완료하였습니다.");
				} else {
					const fileURL = URL.createObjectURL(blob);
					window.open(fileURL, "_blank");
					showWarning(" PDF를 새 탭에서 열었습니다.");
				}
			} else {
				const fileURL = URL.createObjectURL(blob);
				window.open(fileURL, "_blank");
				showSuccess("PDF를 새 탭에서 열었습니다.");
			}
		} catch (error) {
			console.error("Print error:", error);
			showError("PDF 출력 중 오류가 발생했습니다.");
			setMessage("PDF 출력 중 오류가 발생했습니다.");
		} finally {
			setLoadingSpinner(false);
		}
	}, [selectedPUR1030_R01, setMessage, printPdfFromBlob, setLoadingSpinner]);
	

	const handleExcelClick = useCallback(async () => {
		if (!selectedPUR1030_R01) {
			showWarning("선택된 발주내역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_PUR1030_R01('', selectedPUR1030_R01.purchaseOrderNo, PUR1030_R01List.length ?? 0);

		downloadSettingExcel({ responseData: response.data.data, fileName: '발주전표 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [selectedPUR1030_R01]);

	const getParams = (filter: PUR1030_R01Filter) => {
		const params: Partial<PUR1030_R01Filter> = {
			dateRange: filter.dateRange || undefined,
			purchaseOrderNo: filter.purchaseOrderNo || undefined,
			customCd: filter.customCd || undefined,
			orderStatus: filter.orderStatus || undefined,
		};
		return params;
	};

	const renewalAllCount = useCallback(async () => {
		const response = await getPUR1030_R01AllCount(getParams(PUR1030_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [PUR1030_R01Filter, setAllCount]);

	const fetchData = useCallback(async (skipSelection?: boolean) => {
		setScrollTop(null);
		setDetailScrollTop(null);
		setLoadingSpinner(true);
	
		const responseData = (await getPUR1030_R01List(
			'',
			getParams(PUR1030_R01Filter),
			PUR1030_R01List.length ?? 0
		));


		let newList = [...responseData.data.data ] as PUR1030_R01HeaderDto[];
		setPUR1030_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			if (skipSelection !== true) {
				gridRefSelectedRowHandler(
					gridRef,
					setSelectedPUR1030_R01,
					() => true,
				);
			}
			setPUR1030_R01PastFilter(PUR1030_R01Filter);
			setLoadingSpinner(false);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
		}else {
			showWarning('데이터가 없습니다.');
			handleCreateClick();
			setLoadingSpinner(false);
		}
		return responseData;
	}, [PUR1030_R01Filter, PUR1030_R01List, setPUR1030_R01List, setPUR1030_R01PastFilter, setSelectedPUR1030_R01, selectedPUR1030_R01, setScrollTop, setDetailScrollTop]);

	const defaultPUR1030_R01HeaderRow = useCallback(() => {
		const logicCenter = editPUR1030_R01?.logicCenter || wmsCdList[0]?.minorCd || '';
		const warehouseCdListToUse = warehouseCdList.filter(value =>
			value.logicCenter === logicCenter && (value.goodsYn === 'Y' || value.productYn === 'Y')
		);

		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(PUR1030_R01_HEADER_ROW_VALIDATE, {
				compCdList,
				moneyCdList,
				vatTypeList,
				wmsCdList,
				warehouseCdList: warehouseCdListToUse,
			}),
		);
		if (!commonResult.valid) {
			return { ...defaultPUR1030_R01HeaderDto };
		}

		return {
			...defaultPUR1030_R01HeaderDto,
			compCd: compCdList[0].compCd,
			vatType: vatTypeList[0].minorCd,
			moneyCd: moneyCdList[0].minorCd,
			logicCenter,
			warehouseCd: warehouseCdListToUse[0].warehouseCd,
		};
	}, [
		editPUR1030_R01, defaultPUR1030_R01HeaderDto,
		vatTypeList, moneyCdList, compCdList, wmsCdList, warehouseCdList,
		validateCommonCodeLists,
	]);

	const defaultPUR1030_R01DetailRow = useCallback(() => {
		return {
			...defaultPUR1030_R01DetailDto,
			inserted: true,
		}
	}, [defaultPUR1030_R01DetailDto]);

	const fetchOne = useCallback(async () => {
		if (!selectedPUR1030_R01) return;
		setLoadingSpinner(true);
		try {
			const response = await getPUR1030_R01One(selectedPUR1030_R01.purchaseOrderNo!);
			setEditPUR1030_R01({ ...response.data.data });
		} catch (error) {
			console.error("조회 중 오류 발생:", error);
			showError("조회 중 오류가 발생했습니다.");
		}
		setLoadingSpinner(false);
	}, [selectedPUR1030_R01, setEditPUR1030_R01, setLoadingSpinner])

	// 발주내역 상세조회 - useEffect 내부가 아닌 본문에서 useCallback으로 정식 선언
	const fetchDetailList = useCallback(async (purchaseOrderNo: string) => {
		setDetailScrollTop(null);
		const responseData = (await getPUR1030_R01DetailList(purchaseOrderNo)).data.data;
		if (responseData && responseData.length > 0) {
			setPUR1030_R01DetailList(responseData.map((value, idx) => ({
				...value,
				valueIndex: value.valueIndex ?? idx + 1,
				orderIndex: value.orderIndex ?? idx + 1,
				orderIndexSeq: value.orderIndexSeq ?? 0,
				orderPrice: value.orderPrice,
			})));
			setOriginalPUR1030_R01DetailList(responseData);
			setMessage(`${selectedPUR1030_R01?.customNm}의 발주내역 ${responseData.length}건을 조회하였습니다.`);
			setTimeout(() => setMessage(""), 5000);
		} else {
			showError('상세내역이 없습니다.');
			setPUR1030_R01DetailList([]);
			insertPUR1030_R01DetailList([{ ...defaultPUR1030_R01DetailRow() }]);
		}
	}, [
		setMessage,
		setPUR1030_R01DetailList,
		setOriginalPUR1030_R01DetailList,
		insertPUR1030_R01DetailList,
		defaultPUR1030_R01DetailRow,
		setDetailScrollTop,
		selectedPUR1030_R01?.customNm,
	]);

	const initContainerData = useCallback(() => {
		initData();
		removeDeletedPUR1030_R01DetailList();
		removeSelectedPUR1030_R01DetailList();
		setEditPUR1030_R01({ ...defaultPUR1030_R01HeaderRow() })
	}, [compCdList, selectedPUR1030_R01])

	const handleDeleteClick = useCallback(() => {

		if (deletedPUR1030_R01DetailList.length > 0) {
			// 삭제 표시된 행이 있으면 전체 복구
			removeDeletedPUR1030_R01DetailList(deletedPUR1030_R01DetailList);
			removeSelectedPUR1030_R01DetailList();
			setPUR1030_R01DetailList([...PUR1030_R01DetailList]);
		} else if (selectedPUR1030_R01DetailList.length > 0) {
			addDeletedPUR1030_R01DetailList(selectedPUR1030_R01DetailList);
			removeSelectedPUR1030_R01DetailList(selectedPUR1030_R01DetailList);
		}
	}, [selectedPUR1030_R01DetailList, 
		deletedPUR1030_R01DetailList,
		addDeletedPUR1030_R01DetailList,
		removeDeletedPUR1030_R01DetailList,
		removeSelectedPUR1030_R01DetailList,
		setPUR1030_R01DetailList,
		PUR1030_R01DetailList]);
	
	const handleCreateClick = () => {
		setSelectedPUR1030_R01(undefined);
		setEditPUR1030_R01({ ...defaultPUR1030_R01HeaderRow() })
		setPUR1030_R01DetailList([{...defaultPUR1030_R01DetailRow()}]);
		setDeletedPUR1030_R01DetailList([]);
		setSelectedPUR1030_R01DetailList([]);
		setOriginalPUR1030_R01DetailList([]);
		setDetailScrollTop(null);
	}

	const validateInsertData = (header: PUR1030_R01HeaderDto, detailList: PUR1030_R01DetailDto[]) => {
		
		if (!validateString(header.compCd)) {
			showWarning('사업장을 선택해주세요.'); return false;
		}
		if (!validateString(header.customCd)) {
			showWarning('거래처를 입력해주세요.'); return false;
		}
		if(!validateCustomCd(header.customCd, customCdList)) {
			showWarning('거래처가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		if (!header.orderDt) {
			showWarning('발주일자를 입력해주세요.'); return false;
		}
		if (!validateString(header.moneyCd)) {
			showWarning('통화를 선택해주세요.'); return false;
		}
		// if (!validateString(header.empNo)) {
		// 	showWarning('담당자를 선택해주세요.'); return false;
		// }
		// if (!validateEmployeeCd(header.empNo, employeeCdList)) {
		// 	showWarning('담당자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		// }
		if (!validateString(header.vatType)) {
			showWarning('부가세 유형을 선택해주세요.'); return false;
		}
		if (!validateString(header.logicCenter)) {
			showWarning('물류센터를 선택해주세요.'); return false;
		}
		if (header.dueDt === undefined) {
			showWarning('납기일자를 입력해주세요.'); return false;
		}


		if (detailList.length === 0) {
			showWarning('상세내역을 입력해주세요.'); return false;
		}
		for (const detail of detailList) {
			if (!validateString(detail.itemCd)) {
				showWarning('품목코드를 입력해주세요.'); return false;
			}
			if (detail.orderQty === 0) {
				showWarning('발주수량을 입력해주세요.'); return false;
			}
			if(detail.cancelQty > detail.orderQty) {
				showWarning('취소수량은 발주수량보다 클 수 없습니다.'); return false;
			}
			if(detail.cancelQty + detail.completeTransport > detail.orderQty) {
				showWarning('출하완료수량과 취소수량의 합이 주문량보다 클 수 없습니다.'); return false;
			}
			if(detail.inserted === true && detail.completeTransport != 0) {
				showWarning('등록 작업에는 출하완료수량 입력을 할수 없습니다'); return false;
			}
			const activeDetailList = detailList.filter(detail => !deletedPUR1030_R01DetailList.includes(detail.itemCd));
			const otherDetailList = activeDetailList.filter((_, index) => index !== detailList.findIndex(detail => detail.itemCd === _.itemCd));
			if (otherDetailList.some(otherDetail => otherDetail.itemCd === detail.itemCd)) {
				showWarning("중복된 품목코드가 있습니다.\n품목코드: " + detail.itemCd);
				return false;
			}

			if(!itemCdMap.has(detail.itemCd)) {
				showWarning('품목코드가 해당 MES의 품목정보에 존재하지 않습니다.\n품목코드: ' + detail.itemCd); return false;
			}
		}

		return true;
	}

	const setInfoDetailList = useCallback((header: PUR1030_R01HeaderDto, detailList: PUR1030_R01DetailDto[]) => {
		
		return detailList.map((value, idx) => ({
			...value,
			compCd: header.compCd,
			customCd: header.customCd,
		}))
	}, [setPUR1030_R01DetailList])
	
	const handleSaveClick = useCallback(async () => {
		if (isOrderLocked(editPUR1030_R01?.orderStatus)) {
			showWarning('입고가 진행된 발주는 수정할 수 없습니다.');
			return;
		}
		setLoadingSpinner(true);
		let valid = true;
		if(!validateInsertData(editPUR1030_R01!, PUR1030_R01DetailList)) valid = false;
		if(!valid) { setLoadingSpinner(false); return; }
		
		const deletedPUR1030_R01DetailList_Number = deletedPUR1030_R01DetailList.map(value => Number(value));
		let processName = '';
		let newDetailList: PUR1030_R01DetailDto[] = [];
		let newHeaderList: PUR1030_R01HeaderDto[] = [];
		let responseData: PUR1030_R01Dto = {
			purchaseOrderHeaderDto: editPUR1030_R01!,
			purchaseOrderDetailDtoList: PUR1030_R01DetailList
		};

		try {
			
			if (selectedPUR1030_R01) {
				newDetailList = PUR1030_R01DetailList.filter(value => 
					!deletedPUR1030_R01DetailList_Number.includes(value.valueIndex)
				);

				if (newDetailList.length === 0) {
					processName = 'delete';
					const deleteResponse = await deletePUR1030_R01(selectedPUR1030_R01.purchaseOrderNo);

					newHeaderList = PUR1030_R01List.filter(value => value.purchaseOrderNo !== selectedPUR1030_R01.purchaseOrderNo);

					if (deleteResponse && deleteResponse.data) {
						if (deleteResponse.data.successFlag) {
							showSuccess('발주내역이 삭제 되었습니다.');
							setMessage('발주내역이 삭제 되었습니다.');
						}else return;
					}
				} else {
					processName = 'patch';

						const patchResponse = await patchPUR1030_R01({
							purchaseOrderHeaderDto: editPUR1030_R01!,
							purchaseOrderDetailDtoList: setInfoDetailList(editPUR1030_R01!, newDetailList)
						});

						if (patchResponse?.data?.data?.[0] && patchResponse.data.successFlag) {
							responseData = patchResponse.data.data[0];
							newHeaderList = PUR1030_R01List.map(value => {
								if (value.purchaseOrderNo === responseData.purchaseOrderHeaderDto.purchaseOrderNo) {
									return responseData.purchaseOrderHeaderDto;
								}
								return value;
							});
							
							showSuccess('발주내역이 수정 되었습니다.');
							setMessage('발주내역이 수정 되었습니다.');
						}
				}
			} else {
				processName = 'post';
				const postResponse = await postPUR1030_R01({
					purchaseOrderHeaderDto: editPUR1030_R01!,
					purchaseOrderDetailDtoList: setInfoDetailList(editPUR1030_R01!, PUR1030_R01DetailList)
				});
				responseData = postResponse.data.data[0];

				newHeaderList = [
					...PUR1030_R01List,
					responseData.purchaseOrderHeaderDto, // responseData에서 헤더를 가져옵니다.
				] as PUR1030_R01HeaderDto[];
				
				if (postResponse?.data?.data?.[0] && postResponse.data.successFlag) {
					showSuccess('발주내역이 등록 되었습니다.');
					setMessage('발주내역이 등록 되었습니다.');
				}else {
					// 서버 응답이 예상과 다를 경우의 에러 처리
					showWarning('발주 등록 후 서버로부터 올바른 데이터를 받지 못했습니다.');
					setLoadingSpinner(false);
					return;
				}
			}
			
		} catch (error: any) {
			console.log('error :', error.response?.data?.message || error.message);
			showError(error.response?.data?.message || '발주 작업 중 오류가 발생했습니다.');
			setLoadingSpinner(false);
			return;
		}


		if (processName === 'delete') {
			setPUR1030_R01List(newHeaderList);
			setSelectedPUR1030_R01(undefined);
			setPUR1030_R01DetailList([]);
			handleCreateClick();
		}else if (processName === 'patch' || processName === 'post') {
			//header의 orderStatus가 E, C이고 filter의 orderStatus가 N인 경우 리스트에서 해당 발주정보 제거 및 상세행 초기화
			const isCanceledPurchaseOrder = responseData.purchaseOrderHeaderDto.orderStatus === 'E' || responseData.purchaseOrderHeaderDto.orderStatus === 'C';
			if(isCanceledPurchaseOrder && PUR1030_R01Filter.orderStatus === 'N'){
				newHeaderList = PUR1030_R01List.filter(value => value.purchaseOrderNo !== responseData.purchaseOrderHeaderDto.purchaseOrderNo);
				setPUR1030_R01DetailList([]);
				handleCreateClick();
			}else{
				setPUR1030_R01DetailList(responseData.purchaseOrderDetailDtoList);
				setSelectedPUR1030_R01(responseData.purchaseOrderHeaderDto);
				setOriginalPUR1030_R01DetailList(responseData.purchaseOrderDetailDtoList);
				await fetchOneProcess(responseData.purchaseOrderHeaderDto.purchaseOrderNo);
			}
			setPUR1030_R01List(newHeaderList);
		}
		
		// setSelectedPUR1030_R01(undefined);
		setDeletedPUR1030_R01DetailList([]);
		setSelectedPUR1030_R01DetailList([]); // 저장 후 상세행 선택 상태 초기화
		setTimeout(() => {
			setMessage('');
		}, 5000)
		setLoadingSpinner(false);
	}, [
		editPUR1030_R01, 
		selectedPUR1030_R01, 
		PUR1030_R01DetailList, 
		deletedPUR1030_R01DetailList, 
		PUR1030_R01List, setPUR1030_R01List
	]);

	const fetchOneProcess = useCallback(async (purchaseOrderNo: string) => {
		await fetchOne();
		await fetchDetailList(purchaseOrderNo);
	}, [fetchOne, fetchDetailList])

	/** 탭 복귀 시 입력값/그리드는 유지하고 서버 orderStatus만 반영해 잠금 여부를 갱신 */
	const fetchOrderStatus = useCallback(async () => {
		const store = usePUR1030_R01Store.getState();
		const purchaseOrderNo = store.selectedPUR1030_R01?.purchaseOrderNo || store.editPUR1030_R01?.purchaseOrderNo;
		if (!purchaseOrderNo) return;

		try {
			const response = await getPUR1030_R01One(purchaseOrderNo);
			const orderStatus = response.data.data?.orderStatus;
			if (orderStatus === undefined) return;

			const latest = usePUR1030_R01Store.getState();
			if (latest.editPUR1030_R01?.purchaseOrderNo === purchaseOrderNo) {
				const nextEdit = applyOrderStatusOnly(latest.editPUR1030_R01, orderStatus);
				if (nextEdit && nextEdit !== latest.editPUR1030_R01) {
					setEditPUR1030_R01(nextEdit);
				}
			}
			if (latest.selectedPUR1030_R01?.purchaseOrderNo === purchaseOrderNo) {
				const nextSelected = applyOrderStatusOnly(latest.selectedPUR1030_R01, orderStatus);
				if (nextSelected && nextSelected !== latest.selectedPUR1030_R01) {
					setSelectedPUR1030_R01(nextSelected);
				}
			}
			const nextList = applyOrderStatusToList(
				latest.PUR1030_R01List,
				(row) => row.purchaseOrderNo === purchaseOrderNo,
				orderStatus,
			);
			if (nextList !== latest.PUR1030_R01List) {
				setPUR1030_R01List(nextList);
			}
		} catch (error) {
			console.error('발주 상태 조회 실패:', error);
		}
	}, [setEditPUR1030_R01, setSelectedPUR1030_R01, setPUR1030_R01List]);

	// HomeContainer는 activeTab만 렌더하므로, 입고 화면으로 가면 이 컴포넌트는 언마운트된다.
	// 다시 들어오면 mount 시점에 orderStatus만 조회한다. fetchOne은 폼/그리드를 덮어써서 사용하지 않는다.
	useEffect(() => {
		fetchOrderStatus();
	}, [fetchOrderStatus]);

	// 발주내역 상세조회 및 네비게이션 데이터 처리 통합
	useEffect(() => {
		const processDetail = async () => {
			const navData = PUR1021_PUR1030NavigationData ?? PUR1020_PUR1030NavigationData;
			// 1. 네비게이션 데이터가 있는 경우 (우선 처리)
			if (navData) {
				setPUR1021_PUR1030NavigationData(null);
				setPUR1020_PUR1030NavigationData(null);

				try {
					// 목록 갱신하되, 첫 번째 행 자동 선택 방지 (skipSelection = true)
					// await fetchData(true);
					
					// 그리드 선택 해제
					gridRef.current?.api?.deselectAll();

					// 전달받은 데이터로 폼 세팅
					setEditPUR1030_R01({ ...navData.purchaseOrderHeaderDto });
					setPUR1030_R01DetailList(navData.purchaseOrderDetailDtoList);
					setOriginalPUR1030_R01DetailList(navData.purchaseOrderDetailDtoList);

					// 상태 초기화 및 상세조회 트리거 끄기
					usePUR1030_R01Store.setState({
						selectedPUR1030_R01: undefined,
						detailFetchTrigger: false,
						selectedPUR1030_R01DetailList: [],
						deletedPUR1030_R01DetailList: []
					});
				} catch (error) {
					console.error('❌ 네비게이션 데이터 처리 중 오류 발생:', error);
				}
				return;
			}else{

				// 2. 일반 상세조회 (네비게이션 데이터가 없을 때)
				if (!detailFetchTrigger) return;
	
				(detailGridRef.current as any)?.clearRange?.();
	
				if (!selectedPUR1030_R01?.purchaseOrderNo) {
					setDetailFetchTrigger(false);
					return;
				}
				const purchaseOrderNo = selectedPUR1030_R01.purchaseOrderNo;
				await fetchOneProcess(purchaseOrderNo);
				setDetailFetchTrigger(false);

			}
		};

		processDetail();
	}, [
		PUR1020_PUR1030NavigationData, PUR1021_PUR1030NavigationData, selectedPUR1030_R01, detailFetchTrigger,
		fetchData, setPUR1020_PUR1030NavigationData, setPUR1021_PUR1030NavigationData, setEditPUR1030_R01, 
		setPUR1030_R01DetailList, setOriginalPUR1030_R01DetailList, 
		fetchOneProcess
	]);

	useEffect(() => {
		if (selectedPUR1030_R01 && PUR1030_R01DetailList.length === 0) {
			insertPUR1030_R01DetailList([{ ...defaultPUR1030_R01DetailRow() }])
		}
	}, [selectedPUR1030_R01, PUR1030_R01DetailList]);

	return {
		handlePrintClick,
		handleExcelClick,
		fetchData,
		defaultPUR1030_R01HeaderRow,
		defaultPUR1030_R01DetailRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	};
}
